import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  paginationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  page: {
    marginRight: '20px'
  },
  itemRoot: {
    border: '1px solid #0e8bb4',
    backgroundColor: '#fff',
    color: '#0e8bb4',
    fontSize: '13px',
    minWidth: '30px',
    height: '30px',
    lineHeight: '30px'
  },
  itemEllipsis: {
    color: '#0e8bb4',
    backgroundColor: '#fff',
    border: 0
  },
  itemSelected: {
    backgroundColor: '#0e8bb4 !important',
    color: '#fff'
  }
});

export default useStyles;
